import { render, staticRenderFns } from "./selfForm.vue?vue&type=template&id=6784fc60&scoped=true&"
import script from "./selfForm.vue?vue&type=script&lang=js&"
export * from "./selfForm.vue?vue&type=script&lang=js&"
import style0 from "./selfForm.vue?vue&type=style&index=0&id=6784fc60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6784fc60",
  null
  
)

export default component.exports